import React from "react";
import rolexLogo from "../assets/images/rolex-logo.png";

function RolexLogo() {
   return <img src={rolexLogo} alt="Rolex" className="rolex-logo" />;
}

export default RolexLogo;



